// extracted by mini-css-extract-plugin
export default {"language-picker-dropdown":"LanguagePicker-module__language-picker-dropdown__1eNAj","languagePickerDropdown":"LanguagePicker-module__language-picker-dropdown__1eNAj"};